export default (process.env.NODE_ENV === 'production' ? "https://13vitrine.ch/api/" : "http://13vitrine.ch/api/")